import { Form, Input, Button, Row, Space, notification } from 'antd'

import { useTranslation } from 'react-i18next'
import { FORM_TEXT, MESSAGE_TEXT } from '@/config/translation/text'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useMutation } from 'react-query'
import { changeUserPassword } from '@/services'

function UserResetPassword() {
  const { t } = useTranslation()

  const { mutateAsync, isLoading } = useMutation(
    async (data) => await changeUserPassword(data)
  )

  const [form] = Form.useForm()

  const changePassword = async (value) => {
    const data = await mutateAsync(value)
    if (data?.status == 400 || data?.status == 500) {
      notification.error({
        message: data.data.message,
        duration: 4,
        placement: 'top',
      })
    } else {
      notification.success({
        message: 'Password changed successfully',
        duration: 4,
        placement: 'top',
      })
      form.resetFields()
    }
  }

  return (
    <>
      <h2>
        <Row align="middle">
          <Space>
            <ArrowLeftOutlined
              className="hide-on-destop"
              style={{ fontSize: 25 }}
            />
            <strong>Change Password</strong>
          </Space>
        </Row>
      </h2>
      <br />
      <Form
        name="basic"
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 18 }}
        onFinish={changePassword}
        autoComplete="off"
        labelAlign="left"
        form={form}
      >
        <Form.Item
          label={t(FORM_TEXT.CURRENT_PASSWORD)}
          name="password"
          rules={[
            {
              required: true,
              message: t(MESSAGE_TEXT.CURRENT_PASSWORD_REQUIRED),
            },
          ]}
        >
          <Input.Password size="large" />
        </Form.Item>
        <Form.Item
          label={t(FORM_TEXT.NEW_PASSWORD)}
          name="new_password"
          rules={[
            {
              min: 8,
              message: 'New password must be at least 8 characters',
            },
            { required: true, message: t(MESSAGE_TEXT.NEW_PASSWORD_REQUIRED) },
          ]}
        >
          <Input.Password size="large" />
        </Form.Item>
        <Form.Item
          label={t(FORM_TEXT.RETYPE_NEW_PASSWORD)}
          name="confirm_password"
          rules={[
            {
              required: true,
              message: t(MESSAGE_TEXT.PASSWORD_CONFIRM_REQUIRED),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error(t(MESSAGE_TEXT.PASSWORD_CONFIRM_NOT_MATCH))
                )
              },
            }),
          ]}
        >
          <Input.Password size="large" />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 7, span: 18 }}>
          <Button
            disabled={isLoading}
            loading={isLoading}
            block
            type="primary"
            htmlType="submit"
            size="large"
          >
            {'Update Password'}
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}

export default UserResetPassword
